module.exports = __webpack_public_path__ + "static/media/caller.28193cda.jpg";